export default __webpack_public_path__ + "static/media/banner-3.a5b2ee48.jpg";